import { FARE_CALENDAR_TEST_ID } from '@/constants/common.constants';

export const getFareCalendarCellTestID = ({
  isNotAvailable,
  isNotDetermined,
  isNotValid,
  departureDate,
  returnDate,
}) => {
  let testIdPrefix = `${FARE_CALENDAR_TEST_ID}__Departure-${departureDate}`;
  if (returnDate) {
    testIdPrefix += `__Return-${returnDate}`;
  }

  let cellState = '';
  if (isNotAvailable) {
    cellState = '--NoFlightAvailable';
  } else if (isNotDetermined) {
    cellState = '--ClickToShowPrice';
  } else if (isNotValid) {
    cellState = '--Inactive';
  }

  return {
    cellButton: `${testIdPrefix}__Button${cellState}`,
    priceLabel: `${testIdPrefix}__PriceAmountLabel`,
    currencyLabel: `${testIdPrefix}__CurrencyCodeLabel`,
    cheapestLabel: `${testIdPrefix}__CheapestLabel`,
  };
};
